export const mockTestimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Luxury Hotel Chain",
    industry: "Hospitality",
    rating: 5,
    text: "Shyaam transformed our digital presence completely. Our booking rates increased by 180% within 6 months of working with him. His expertise in Meta ads is unmatched.",
    image: "https://ui-avatars.com/api/?name=Rajesh+Kumar&background=0f172a&color=fff"
  },
  {
    id: 2,
    name: "Dr. Priya Sharma",
    company: "MedCare Clinic",
    industry: "Healthcare",
    rating: 5,
    text: "Working with Digital Shyaam was a game-changer for our clinic. Patient inquiries increased by 250% and our cost per lead dropped by 40%. Highly recommended!",
    image: "https://ui-avatars.com/api/?name=Priya+Sharma&background=0f172a&color=fff"
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "Career Success Academy",
    industry: "Coaching",
    rating: 5,
    text: "Shyaam's strategic approach to Google Ads helped us achieve 3x ROI consistently. His data-driven methodology and transparent reporting set him apart from others.",
    image: "https://ui-avatars.com/api/?name=Amit+Patel&background=0f172a&color=fff"
  }
];

export const mockCaseStudies = [
  {
    id: 1,
    title: "Luxury Resort Campaign",
    industry: "Hospitality",
    challenge: "Low online visibility and declining bookings during off-season",
    solution: "Implemented targeted Meta ads campaign with dynamic retargeting and seasonal offers",
    results: [
      "180% increase in direct bookings",
      "65% reduction in cost per acquisition",
      "42% improvement in ROAS"
    ],
    duration: "6 months",
    metrics: {
      bookings: "+180%",
      cpa: "-65%",
      roas: "4.2x"
    }
  },
  {
    id: 2,
    title: "Healthcare Lead Generation",
    industry: "Healthcare",
    challenge: "Need to generate qualified patient leads while maintaining compliance",
    solution: "Developed comprehensive Google Ads strategy with localized targeting and conversion optimization",
    results: [
      "250% increase in patient inquiries",
      "40% lower cost per lead",
      "95% lead quality score"
    ],
    duration: "4 months",
    metrics: {
      leads: "+250%",
      cpl: "-40%",
      quality: "95%"
    }
  },
  {
    id: 3,
    title: "Coaching Institute Growth",
    industry: "Coaching",
    challenge: "Competing with established players in saturated market",
    solution: "Created high-converting landing pages with multi-channel ad campaigns and A/B testing",
    results: [
      "320% growth in student enrollments",
      "ROI of 3.8x maintained consistently",
      "55% reduction in funnel drop-off"
    ],
    duration: "8 months",
    metrics: {
      enrollments: "+320%",
      roi: "3.8x",
      conversion: "+55%"
    }
  }
];

export const services = [
  {
    id: 1,
    title: "Meta Ads Management",
    description: "Strategic Facebook & Instagram advertising campaigns that drive measurable results and maximize your ROI.",
    features: [
      "Campaign strategy & setup",
      "Audience targeting & segmentation",
      "Creative optimization & A/B testing",
      "Performance tracking & reporting"
    ],
    icon: "target"
  },
  {
    id: 2,
    title: "Google Ads Management",
    description: "Data-driven Google Ads campaigns across Search, Display, and Shopping networks to capture high-intent customers.",
    features: [
      "Keyword research & optimization",
      "Ad copy creation & testing",
      "Bid management & budget optimization",
      "Conversion tracking & analytics"
    ],
    icon: "search"
  },
  {
    id: 3,
    title: "Landing Page Creation",
    description: "High-converting landing pages designed to transform visitors into customers with compelling design and copy.",
    features: [
      "Conversion-focused design",
      "Mobile-responsive layouts",
      "A/B testing & optimization",
      "Fast loading & SEO optimized"
    ],
    icon: "layout"
  },
  {
    id: 4,
    title: "Marketing Consulting",
    description: "Strategic guidance and expert advice to elevate your entire digital marketing ecosystem and drive growth.",
    features: [
      "Marketing strategy development",
      "Campaign audit & optimization",
      "Team training & workshops",
      "Growth roadmap planning"
    ],
    icon: "lightbulb"
  }
];

export const industries = [
  {
    id: 1,
    name: "Hospitality",
    description: "Hotels, resorts, restaurants, and travel services",
    projects: "150+ projects",
    icon: "building"
  },
  {
    id: 2,
    name: "Coaching",
    description: "Educational institutes, training centers, and online courses",
    projects: "200+ projects",
    icon: "graduation-cap"
  },
  {
    id: 3,
    name: "Healthcare",
    description: "Clinics, hospitals, wellness centers, and medical services",
    projects: "150+ projects",
    icon: "heart-pulse"
  }
];
